export default __webpack_public_path__ + "img/aa25d2fd1c6b669c040941b8b2ccb1ef.png";